import Select from '@utils/common/select/module'

const select = new Select()
  .url('/sysOffice/getOfficePageForRole')
  .baseURL(process.env.VUE_APP_BASE_DATA_API)
  .params(() => {
    return { usingFlag: '1' }
  })
  .value('officeNo')
  .label(option => `${option.officeNo}-${option.name}`)

export default select
